import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useWorkspace } from "@/context/WorkspaceContext";
import { Rocket } from "lucide-react";

export default function OnboardingNudge() {
  const { active, workspaces } = useWorkspace();
  const [postCount, setPostCount] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!active) return;
    api.get(`/posts?workspace_id=${active.id}`).then((r) => setPostCount(r.data.length)).catch(() => {});
  }, [active]);

  if (!active || postCount === null) return null;

  const stepsLeft = [
    (workspaces?.length || 0) > 0,
    (active.connected_accounts?.length || 0) > 0,
    postCount > 0,
  ].filter((d) => !d).length;

  if (stepsLeft === 0) return null;

  const openWizard = () => {
    localStorage.removeItem("gs_onboarding_done");
    navigate("/dashboard");
  };

  return (
    <button
      data-testid="onboarding-nudge"
      onClick={openWizard}
      className="mx-3 mb-3 flex items-center gap-2.5 rounded-lg border border-primary/40 bg-primary/10 px-3 py-2.5 text-left hover:bg-primary/15 transition-colors"
    >
      <Rocket className="h-4 w-4 text-primary shrink-0" />
      <div className="min-w-0">
        <div className="text-xs font-medium text-primary">Finish setup</div>
        <div className="text-[11px] text-muted-foreground" data-testid="onboarding-nudge-count">
          {stepsLeft} step{stepsLeft > 1 ? "s" : ""} left
        </div>
      </div>
    </button>
  );
}
